<template>
    <div>
        <div class="">
            <div class="flex flex-col pb-3">
                <Field field_name="Policy">
                    <textarea class="p-3 border-next-gray-md-dark border-2 w-full" rows="6" v-model="infoPolicyModel"></textarea>
                </Field>
            </div>
            <div class="flex flex-col pb-3">
                <Field field_name="Data offerta">
                    <input v-model="dataOffertaModel" type="date"
                           class="flex-grow p-7px bg-next-gray-md-dark hover:bg-white">
                </Field>
            </div>
            <Field field_name="Termini di pagamento">
                <textarea class="p-3 border-next-gray-md-dark border-2 w-full" rows="6" v-model="terminiPagamentoModel"></textarea>
            </Field>
        </div>
        <div class="flex justify-end gap-3 pt-5">
            <NextButton variant="outline-secondary"
                        @click="$emit('chiudi')"
                        class="w-44 py-2 px-4">
                Chiudi
            </NextButton>
            <NextButton variant="primary" :disabled="$attrs.waiting"
                        @click="save"
                        class="w-44 py-2 px-4">
                Salva
            </NextButton>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";


@Options({
    name:'InfoPolicy',
    components: {
        Field,
        NextButton,
        MultiselectOption
    },
    props: {
        infoPolicy: String,
        dataOfferta: String,
        terminiPagamento: String,
    }
})
export default class InfoPolicy extends Vue {

    infoPolicy!: string
    dataOfferta!: string
    terminiPagamento!: string

    infoPolicyModel!:string
    dataOffertaModel!:string
    terminiPagamentoModel!:string

    init() {
        this.infoPolicyModel = this.infoPolicy
        this.dataOffertaModel = this.dataOfferta
        this.terminiPagamentoModel = this.terminiPagamento
    }


    created(){
        this.init()
    }

    save(){
        this.$emit('update:waiting', true)
        //@ts-ignore
        this.$emit('update:infoPolicy', this.infoPolicyModel)
        this.$emit('update:dataOfferta', this.dataOffertaModel)
        this.$emit('update:terminiPagamento', this.terminiPagamentoModel)
        this.$nextTick(()=>{
            this.$emit('save')
        })
    }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
